import type {
  ArrayField,
  SelectField,
  StructuredArrayField,
  TextField,
} from "@/v2/framework/dialog/types";

import { aggregateStructuredArrayMessage } from "./structured-array-field";

export type RegistryLeafField =
  | TextField
  | SelectField
  | ArrayField
  | StructuredArrayField;

export const isValueEmptyForLeafField = (
  field: TextField | SelectField | ArrayField,
  value: unknown,
): boolean => {
  if (field.type === "text-field" && field.inputType === "number") {
    if (value === undefined || value === null) return true;
    if (typeof value === "number") return Number.isNaN(value);
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed === "") return true;
      const n = Number(trimmed);
      return !Number.isFinite(n);
    }
    if (typeof value === "bigint") return false;
    return true;
  }

  if (value === undefined || value === null) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  return false;
};

export const validateNonStructuredField = (
  field: TextField | SelectField | ArrayField,
  value: unknown,
  values: Record<string, unknown>,
): string | undefined => {
  const empty = isValueEmptyForLeafField(field, value);
  const trimmedLabel = typeof field.label === "string" ? field.label.trim() : "";
  const label = trimmedLabel !== "" ? trimmedLabel : field.name;

  if (field.required && empty) {
    return `${label} is required`;
  }
  if (!empty && field.validate) {
    return field.validate(value, values);
  }
  return undefined;
};

export const validateField = (
  field: RegistryLeafField,
  value: unknown,
  values: Record<string, unknown>,
): string | undefined => {
  if (field.type === "structured-array-field") {
    return aggregateStructuredArrayMessage(field, value, values, validateNonStructuredField);
  }
  return validateNonStructuredField(field, value, values);
};
